import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useMutation } from "@apollo/client/react";
import { setAuthorizationToken } from "@/authorizationToken";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle, } from "@/components/ui/alert-dialog";
import { setSession } from "@/features/sessionSlice";
import { sessionSelector } from "@/features/sessionSlice";
import { RefreshDocument } from "@/gql/graphql";
import { useAppDispatch, useAppSelector } from "@/hooks";
export default function AccountConfirmationOverlay() {
    const { user, loading } = useAppSelector(sessionSelector);
    const dispatch = useAppDispatch();
    const [refresh] = useMutation(RefreshDocument);
    const shouldBlock = !loading && !!user?.id && !user?.confirmedAt;
    useEffect(() => {
        if (!shouldBlock)
            return;
        let bc;
        try {
            bc = new BroadcastChannel("igor-account-confirmed");
        }
        catch {
            return;
        }
        bc.onmessage = async () => {
            try {
                const { data } = await refresh();
                if (data?.refresh) {
                    if (data.refresh.token) {
                        setAuthorizationToken(data.refresh.token);
                    }
                    dispatch(setSession({
                        user: data.refresh.user,
                        customer: { ...data.refresh.customer, attrs: data.refresh.customer.attrs },
                        token: data.refresh.token,
                        loading: false,
                    }));
                }
            }
            catch (error) {
                console.error("Failed to refresh session after confirmation:", error);
            }
        };
        return () => bc.close();
    }, [shouldBlock, refresh, dispatch]);
    if (!shouldBlock) {
        return null;
    }
    return (_jsx(AlertDialog, { open: true, children: _jsxs(AlertDialogContent, { children: [_jsx(AlertDialogHeader, { children: _jsx(AlertDialogTitle, { children: "Bitte best\u00E4tige deinen Account" }) }), _jsx(AlertDialogDescription, { children: "Du musst deinen Account best\u00E4tigen, bevor du die Software nutzen kannst. Schau in dein Postfach und klicke auf den Best\u00E4tigungslink." })] }) }));
}
